// マウスホイール / Shift+ホイール / Ctrl+ホイールの統合ハンドラ。
// - ホイール（縦）: 縦パン
// - Shift + ホイール: 横パン
// - Ctrl + ホイール: マウス位置中心のズーム

import { useEffect, type RefObject } from "react";
import { useCanvasStore } from "../store/canvas-store";
import { stepZoomIn, stepZoomOut, zoomAt } from "../../../lib/canvas-coordinates";

const WHEEL_PAN_SCALE = 1; // wheel delta をそのまま pan 量へ反映

export function useWheelPanZoom(containerRef: RefObject<HTMLElement | null>): void {
  const setView = useCanvasStore((s) => s.setView);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return undefined;

    const onWheel = (event: WheelEvent): void => {
      event.preventDefault();
      const { view } = useCanvasStore.getState();
      if (event.ctrlKey || event.metaKey) {
        // Ctrl + ホイール: マウス位置中心のズーム（段階）
        const nextZoom = event.deltaY < 0 ? stepZoomIn(view.zoom) : stepZoomOut(view.zoom);
        setView(zoomAt(view, { x: event.clientX, y: event.clientY }, nextZoom));
        return;
      }
      if (event.shiftKey) {
        // Shift + ホイール: 横パン
        setView({ ...view, panX: view.panX - event.deltaY * WHEEL_PAN_SCALE });
        return;
      }
      // 通常ホイール: 縦パン
      setView({ ...view, panY: view.panY - event.deltaY * WHEEL_PAN_SCALE });
    };

    container.addEventListener("wheel", onWheel, { passive: false });
    return () => container.removeEventListener("wheel", onWheel);
  }, [containerRef, setView]);
}
